module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Fifty-Shades-Freed.a8f2ad2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Fifty-Shades-Freed.jpg
// module id = mNGZ
// module chunks = 0